import collectionStoresReducer from '@Src/slices/collectionStoresSlice';
import deliveryAddressesReducer from '@Src/slices/deliveryAddressesSlice';
import deliveryStoresReducer from '@Src/slices/deliveryStoresSlice';
import locationReducer from '@Src/slices/locationSlice';
import orderSettingsReducer from '@Src/slices/orderSettingSlice';
import { configureStore } from './utility/reduxUtils';

export const rootReducer = {
  collectionStores: collectionStoresReducer,
  deliveryAddresses: deliveryAddressesReducer,
  deliveryStores: deliveryStoresReducer,
  location: locationReducer,
  orderSettings: orderSettingsReducer,
};
export const store = configureStore({
  reducer: rootReducer,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
